var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraduationHatSolid = function SvgGraduationHatSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.577V14.23a.5.5 0 0 1 .745-.436l5.371 3.022a2 2 0 0 0 1.982-.012l5.152-2.98a.5.5 0 0 1 .75.433v2.576a2 2 0 0 1-1.016 1.741l-5.03 2.842a2 2 0 0 1-2.04-.044l-4.972-3.097A2 2 0 0 1 5 16.577Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.734a1 1 0 0 1-.553.895l-9.73 4.878c-.263.132-.394.198-.532.223a.999.999 0 0 1-.37 0c-.138-.025-.27-.091-.532-.223L3 10.354v5.466a1 1 0 0 1-2 0V8.733a1 1 0 0 1 .553-.894l9.668-4.834c.093-.048.286-.146.502-.187a1.5 1.5 0 0 1 .554 0c.216.04.41.14.502.187l9.668 4.834a1 1 0 0 1 .553.894Z",
    fill: "currentcolor"
  })));
};
export default SvgGraduationHatSolid;